import PublicSplitDomainListsDashboard from "./PublicSplitDomainListsDashboard";

export default PublicSplitDomainListsDashboard;
